import { BatchLoadExperimentsData } from 'business/models/Models';
import React from 'react';
import { BatchloadTable, ColumnDef } from './BatchloadTable';
import { FixedTableWidth } from './utils';

interface TableProps {
  tableData: BatchLoadExperimentsData[];
  onReady?: () => void;
}

const BatchLoadExperimentTable = ({ tableData, onReady }: TableProps) => {
  const columns: ColumnDef[] = [
    { key: 'status', title: 'Status', showStatusBorder: false, id: 'status' },
    {
      key: 'errorDescription',
      title: 'Error Description',
      showStatusBorder: false,
      id: 'errordescription',
    },
    { key: 'folder', title: 'Folder', showStatusBorder: true, id: 'folder' },
    { key: 'project', title: 'Project', showStatusBorder: true, id: 'project' },
    { key: 'subFolder', title: 'Sub Folder', showStatusBorder: true, id: 'subfolder' },
    { key: 'user', title: 'User', showStatusBorder: true, id: 'user' },
    {
      key: 'sample',
      title: 'Protein Formulation Name',
      showStatusBorder: true,
      id: 'sample',
    },
    { key: 'class', title: 'Class', showStatusBorder: true, id: 'class' },
    {
      key: 'datePrepared',
      title: 'Date Prepared',
      showStatusBorder: true,
      id: 'dateprepared',
    },
    {
      key: 'liquidClass',
      title: 'Liquid Class',
      showStatusBorder: true,
      id: 'liquidclass',
    },
    { key: 'volume', title: 'Volume μL', showStatusBorder: true, id: 'volume' },
    {
      key: 'storageTemp',
      title: 'Storage Temp. °C',
      showStatusBorder: true,
      id: 'storagetemp',
    },
    {
      key: 'extinctionCoefficient',
      title: 'Extinction Coefficient',
      showStatusBorder: true,
      id: 'extinctioncoefficient',
    },
    {
      key: 'notebookPage',
      title: 'Notebook Page#',
      showStatusBorder: true,
      id: 'notebookpage',
    },
    { key: 'screen', title: 'Screen', showStatusBorder: true, id: 'screen' },
    {
      key: 'screenLotID',
      title: 'Screen Lot ID',
      showStatusBorder: true,
      id: 'screenlotid',
    },
    { key: 'seed', title: 'Seed', showStatusBorder: true, id: 'seed' },
    {
      key: 'temperature',
      title: 'Temperature',
      showStatusBorder: true,
      id: 'temperature',
    },
    { key: 'schedule', title: 'Schedule', showStatusBorder: true, id: 'schedule' },
    { key: 'plateType', title: 'Plate Name', showStatusBorder: true, id: 'platetype' },
    {
      key: 'plateBarcode',
      title: 'Plate Barcode',
      showStatusBorder: true,
      id: 'platebarcode',
    },
    {
      key: 'plateLocalID',
      title: 'Plate Local ID',
      showStatusBorder: true,
      id: 'platelocalid',
    },
    { key: 'dropNumber', title: 'Drop Number', showStatusBorder: true, id: 'dropnumber' },
    { key: 'wellVolul', title: 'Well Vol μl', showStatusBorder: true, id: 'wellvolul' },
    { key: 'dropVolnl', title: 'Drop Vol nl', showStatusBorder: true, id: 'dropvolnl' },
    {
      key: 'samplePercentage',
      title: 'Sample%',
      showStatusBorder: true,
      id: 'samplepercentage',
    },
    {
      key: 'proteinLotId',
      title: 'Protein Lot ID',
      showStatusBorder: true,
      id: 'proteinlotid',
    },
    { key: 'protein', title: 'Protein', showStatusBorder: true, id: 'protein' },
    { key: 'lot', title: 'Lot', showStatusBorder: true, id: 'lot' },
    { key: 'mWkDa', title: 'MW(kDa)', showStatusBorder: true, id: 'mwkda' },
    { key: 'concentration', title: 'Conc.', showStatusBorder: true, id: 'concentration' },
    { key: 'ligand', title: 'Ligand', showStatusBorder: true, id: 'ligand' },
    { key: 'lot2', title: 'Lot 2', showStatusBorder: true, id: 'lot2' },
    { key: 'mWkDa2', title: 'MW(kDa) 2', showStatusBorder: true, id: 'mwkda2' },
    {
      key: 'concentration2',
      title: 'Conc. 2',
      showStatusBorder: true,
      id: 'concentration2',
    },
    { key: 'compound', title: 'Compound', showStatusBorder: true, id: 'compound' },
    { key: 'lot3', title: 'Lot 3', showStatusBorder: true, id: 'lot3' },
    { key: 'mWkDa3', title: 'MW(kDa) 3', showStatusBorder: true, id: 'mwkda3' },
    {
      key: 'concentration3',
      title: 'Conc. 3',
      showStatusBorder: true,
      id: 'concentration3',
    },
    {
      key: 'experimentNotes',
      title: 'Experiment Notes',
      showStatusBorder: true,
      id: 'experimentnotes',
    },
    {
      key: 'formulationNotes',
      title: 'Formulation Notes',
      showStatusBorder: true,
      id: 'formulationnotes',
    },
  ];

  return (
    <BatchloadTable
      id="batchloadexperimenttable"
      columns={columns}
      tableData={tableData}
      onReady={onReady}
      customHeight={'34vh'}
      customWidth={FixedTableWidth}
    />
  );
};

export default BatchLoadExperimentTable;
